<template>
  <section class="page shop container">
    <div class="shop__title" :class="{'not-loaded': notLoaded}">
      <AppTitle v-if="!isMobile" title="lof" size="medium"/>
    </div>

    <div v-if="categories.length > 0 && !isMobile" class="shop__categories">
      <div class="shop__categories__wrapper">
        <div class="shop__categories__inner">
          <a class="shop__category" v-for="(item, index) in categories" :key="index" @click="onClickCategory($event, item.term_id)">{{ item.name }} </a>
          <a class="shop__category__clear" @click="onClickClearCategory" v-if="selectedCategories.length"> Clear </a>
        </div>
      </div>
    </div>

    <div v-if="categories.length > 0 && isMobile" class="shop__categories">
      <div class="shop__categories__inner">
        <a class="shop__category" v-for="(item, index) in categories" :key="index" @click="onClickCategory($event, item.term_id)">{{ item.name }} </a>
        <a class="shop__category__clear" @click="onClickClearCategory" v-if="selectedCategories.length"> Clear </a>
      </div>
    </div>

    <div class="shop__grid" ref="grid" :class="{'not-loaded': notLoaded}">
      <AppLoader ref="loader"/>
      <div v-if="content" class="shop__grid__wrapper">
        <template v-if="isMobile">
          <div v-for="(item, index) in mobileColumns" :key="`col-${index}`" class="shop__grid__col">
            <div class="shop__grid__item" v-for="(item2, index2) in item" :key="index2">
              <AppProductCard :page="currentDataPage" :colIndex="index" :itemIndex="index2" :content="item2" />
            </div>
          </div>
        </template>
        <template v-else>
          <div v-for="(item, index) in columns" :key="`col-${index}`" class="shop__grid__col">
            <div class="shop__grid__item" v-for="(item2, index2) in item" :key="index2">
              <AppParallaxeElem v-if="index === 1" :direction="1" :amount="0.1">
                <AppProductCard :page="currentDataPage" :colIndex="index" :itemIndex="index2" :content="item2" :invertScale="0.9"/>
              </AppParallaxeElem>
              <AppParallaxeElem :amount="0.1" v-else>
                <AppProductCard :page="currentDataPage" :colIndex="index" :itemIndex="index2" :content="item2" :invertScale="0.9" />
              </AppParallaxeElem>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="shop__more" v-show="canLoadMore">
      <AppButtonMore text="See more" ref="moreBtn"/>
    </div>

  </section>
</template>

<script>
  import Page from '@/mixins/Page'

  import AppProductCard from '@/components/AppProductCard'
  import AppLoader from '@/components/AppLoader'
  import AppTitle from '@/components/AppTitle.vue'
  import AppButtonMore from '@/components/AppButtonMore.vue'
  import AppParallaxeElem from '@/components/AppParallaxeElem.vue'

  import getAbsoluteBoundingRect from '@/utils/getAbsoluteBoundingRect.js'

  export default {
    name: 'Shop',

    mixins: [
        Page
    ],

    components: {
      AppTitle,
      AppProductCard,
      AppLoader,
      AppButtonMore,
      AppParallaxeElem
    },

    computed: {
      columns() {
        const arr1 = this.content.filter((item, index) => {
          return (index + 1) % 3 === 1
        })
        const arr2 = this.content.filter((item, index) => {
          return (index + 1) % 3 === 2
        })
        const arr3 = this.content.filter((item, index) => {
          return (index + 1) % 3 === 0
        })

        return [arr1, arr2, arr3]
      },

      mobileColumns() {
        const arr1 = this.content.filter((item, index) => {
          return (index + 1) % 2 === 0
        })
        const arr2 = this.content.filter((item, index) => {
          return (index + 1) % 2 === 1
        })

        return [arr1, arr2]
      }
      
    },

    data() {
      return {
        content: null,
        canLoadMore: true,
        categories: [],
        selectedCategories: [],
        currentDataPage: 1
      }
    },

    created()
    {
      this.currentDataPage = parseInt(this.$route.query.page ? this.$route.query.page : 1)

      const endpoint = `/wp-json/acf/v3/products?per_page=${9 * this.currentDataPage}`
      this.loadDatas(endpoint, (res) => {
        
        this.content = res
        this.onLoadedDatas()

        this.$refs.moreBtn.addEventListeners()
        this.checkLoadMoreButton(res)

        if(this.$route.query.col >= 0 && this.$route.query.item >= 0)
        {
          this.scrollToCurrentItem()
        }
        else
        {
          window.scrollTo(0, 0)
        }
      })
      this.loadCategories()
    },

    mounted()
    {
    },

    methods: {
      scrollToCurrentItem()
      {
        this.$nextTick(() => {
          const $col = this.$el.querySelectorAll('.shop__grid__col')[this.$route.query.col]
          const $item = $col.querySelectorAll('.shop__grid__item')[this.$route.query.item]
          const bounds = getAbsoluteBoundingRect($item)
          const scrollTo = bounds.top - window.innerHeight / 2 + bounds.height / 2

          window.scrollTo(0, scrollTo)
        })
      },

      loadCategories()
      {

        const url = process.env.VUE_APP_WP_API + `/wp-json/acf/v3/pages/46`

        fetch(url)
          .then((res) => res.json())
          .then((res) =>
          {
            this.categories = res.acf.product_categories_displayed
          })
      },

      loadProductsByCategories()
      {
        this.currentDataPage = 1

        this.$refs.loader.enable()
        let productEndpoint = `/wp-json/wp/v2/products?per_page=9&categories=`

        let additionalEndpoint = ''

        for(let i = 0; i < this.selectedCategories.length; i++)
        {
          if(i > 0)
          {
            additionalEndpoint += ','
          }

          additionalEndpoint += this.selectedCategories[i]
        }

        this.isLoading = true

        const url = process.env.VUE_APP_WP_API + productEndpoint + additionalEndpoint

        fetch(url)
          .then((res) => res.json())
          .then((res) =>
          {
            this.content = []
            this.content = res

            window.scrollTo(0, 1)

            this.checkLoadMoreButton(res)

            setTimeout(() => {
              this.isLoading = false
              this.$refs.loader.disable()
            }, 50)
          })
      },

      checkLoadMoreButton(res)
      {
          if(res.length < 9)
          {
            this.canLoadMore = false
          }
          else
          {
            this.canLoadMore = true
          }
      },

      loadMore()
      {
        if(this.isLoadingMore)
          return

        this.isLoadingMore = true
        this.$refs.moreBtn.isLoading = true

        this.currentDataPage += 1

        let url

        if(this.selectedCategories.length > 0)
        {
          let additionalEndpoint = ''

          for(let i = 0; i < this.selectedCategories.length; i++)
          {
            if(i > 0)
            {
              additionalEndpoint += ','
            }

            additionalEndpoint += this.selectedCategories[i]
          }

          url = process.env.VUE_APP_WP_API + `/wp-json/wp/v2/products?per_page=9&page=${this.currentDataPage}&categories=${additionalEndpoint}`
        }
        else
        {
          url = process.env.VUE_APP_WP_API + `/wp-json/wp/v2/products?per_page=9&page=${this.currentDataPage}`
        }

        fetch(url)
          .then((res) => res.json())
          .then((res) =>
          {
            for(let i = 0; i < res.length; i++)
            {
              this.content.push(res[i])
            }

            this.$router.push({ query: Object.assign({}, this.$route.query, { page: this.currentDataPage}) })

            this.checkLoadMoreButton(res)

            this.$refs.moreBtn.isLoading = false
            this.isLoadingMore = false
          })
      },

      onClickCategory(ev, id)
      {
        if(ev.target.classList.contains('is-active'))
        {
          ev.target.classList.remove('is-active')
          // delete the category
          const index = this.selectedCategories.indexOf(id)

          if (index > -1) 
          {
            this.selectedCategories.splice(index, 1)
          }
        }
        else
        {
          ev.target.classList.add('is-active')
          this.selectedCategories.push(id)
        }

        this.loadProductsByCategories()
      },

      onClickClearCategory()
      {
        const $activeCategories = this.$el.querySelectorAll('.shop__category.is-active');

        [].forEach.call($activeCategories, (item) => {
            item.classList.remove('is-active')
        })

        this.selectedCategories = []
        this.loadProductsByCategories()
      },

      onMouseOverItem(ev)
      {
        ev.target.parentNode.classList.add('is-active')
      },

      onMouseLeaveItem(ev)
      {
        ev.target.classList.remove('is-active')
      },
    }
  }
</script>


<style lang="stylus">
  .shop
    // padding-top 15vh
    text-align center

    @media(max-width: 768px)
      // padding-top 25px

  .shop__title
    position relative
    interpolate('margin-bottom', 768px, 2560px, 30px, 100px);
    margin-bottom 40px
    // transform translateY(6vh)
    transform translate3d(0, 0px, 0)
    transition transform 1.2s $ease-in-out-circ 0s

    &.not-loaded
      transform translate3d(0, 50px, 0)
      transition transform 0s $ease-in-out-circ

      @media(max-width 768px)
        transform translate3d(0, 0px, 0)

    @media(max-width: 768px)
      margin-bottom 0


  .shop__test
    position fixed

  .shop__categories
    position absolute
    // right -100px
    // top -170px
    // bottom 0
    // top 0
    right 0
    width calc(100% / 36 * 22)
    margin 0 calc(100% / 36 * 7)
    interpolate('top', 768px, 2560px, 100px, 240px);
    text-align end
    // right 0

    @media(max-width: 768px)
      position relative
      top 0
      right 0
      width calc(100% / 16 * 7)
      margin-left calc(100% / 16 * 9)
      margin-top 20px

  .shop__categories__wrapper
    display inline-block

  .shop__categories__inner
    z-index 5
    position fixed
    margin-left calc(100% / 32 * 1)
    display flex
    flex-direction column
    align-items flex-start

    @media(max-width: 768px)
      position relative

  .shop__category
    cursor pointer
    position relative
    display block
    text-transform uppercase
    interpolate('font-size', 1600px, 2560px, 25px, 35px);

    @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 15px, 25px);

    @media(max-width: 768px)
      line-height 1.5

    &:after
      content ''
      position absolute
      top 50%
      left 0
      width 100%
      height 1px
      background-color $black
      transform-origin center right
      transform scaleX(0) scaleY(1)
      transition transform 0.4s $ease-in-out-circ

    &.is-active
      &:after
        transform scaleX(1) scaleY(1)
        transform-origin center left

  .shop__category__clear
    margin-top 30px
    cursor pointer
    position relative
    display block
    text-transform uppercase
    interpolate('font-size', 1600px, 2560px, 20px, 25px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 13px, 20px);

    @media(max-width: 768px)
      margin-top 10px
      font-size 14px
      line-height 1.5
  
  .shop__grid
    position relative

    transform translate3d(0, 0px, 0)
    transition transform 1.2s $ease-in-out-circ 0s

    &.not-loaded
      transform translate3d(0, 50px, 0)
      transition transform 0s $ease-in-out-circ

      @media(max-width 768px)
        transform translate3d(0, 0px, 0)

  .shop__grid__wrapper
    position relative
    width calc(100% / 36 * 22)
    margin 0 auto
    display flex
    flex-wrap wrap
    justify-content space-between

    @media(max-width 768px)
      width 100%
      margin-top 20px

  .shop__grid__inner
    position relative
    width 100%
    height 100%

  .shop__grid__col
    width calc(100% / 22 * 6)

    @media(max-width 768px)
      width calc(100% / 16 * 7)
      margin-left calc(100% / 16)

    &:last-child
      @media(max-width 768px)
        transform translateY(50px)

  .shop__grid__item
    margin-bottom 40px

    @media(max-width 768px)
      margin-bottom 20px
  
  .shop__more
    display inline-block
    width calc(100% / 36 * 22)
    margin-top 40px

    @media(max-width 768px)
      width 100%
      margin-top 80px

</style>
